import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import BarChart from "src/components/Charts/BarChart";
import { StatusesColors } from "src/resources/enum";
import { RoutePaths } from "src/resources/enum";
import { formatNumber, isCivilDefenseUser } from "src/utils/helpers";

interface OpenATECasesProps {}

const OpenATECases = ({ title = "" }) => {
  const navigate = useNavigate();
  const {
    ateCasesStatisticsData,
    ateCasesTotalCount,
    isAteCasesStatisticsDataLoaded,
  } = useSelector((state: any) => state.dashboard);
  const [chartData, setChartData] = useState<any>({});

  const { t } = useTranslation(["common", "registration", "dashboard"]);
  useEffect(() => {
    const keysArray = Object.keys(ateCasesStatisticsData);
    const valuesArray = Object.values(ateCasesStatisticsData);
    const data = [
      {
        data: valuesArray,
        backgroundColor: [
          StatusesColors.Completed,
          StatusesColors.InProgress,
          StatusesColors.Exceeded,
          StatusesColors.OnHold,
        ],
        barThickness: 15,
        categoryPercentage: 1,
      },
    ];
    setChartData({ labels: keysArray, datasets: data });
  }, [ateCasesStatisticsData]);
  return (
    <Card className="card ate-card">
      <div className="d-flex justify-content-between flex-column pt-2">
        <div className="d-flex justify-content-between align-items-center ">
          <h6 className="card-title">{title}</h6>
          <Button
            className="edit-btn light-primary-btn m-0"
            onClick={() => {
              if (title === t("faults"))
                navigate(RoutePaths.AllCases);
              else navigate(RoutePaths.ATECases);
            }}
            label={t("viewRequests")}
          />
        </div>
        <div>
          <span className="card-2-1-text-number" title={ateCasesTotalCount}>
            {formatNumber(ateCasesTotalCount)}
          </span>
        </div>
      </div>
      {isAteCasesStatisticsDataLoaded && (
        <>
          <div className="bar-chart-container">
            {chartData.datasets && <BarChart chartData={chartData} />}
          </div>
          <div className="stats-row mt-3 open-ate-stats">
            <p className="stats-row__item">
              <span
                className="dot"
                style={{ backgroundColor: StatusesColors.Completed }}
              ></span>
              {t("completed")}
            </p>
            <p className="stats-row__item">
              <span
                className="dot"
                style={{ backgroundColor: StatusesColors.InProgress }}
              ></span>
              {t("inProgress")}
            </p>
            <p className="stats-row__item">
              <span
                className="dot"
                style={{ backgroundColor: StatusesColors.Exceeded }}
              ></span>
              {isCivilDefenseUser() ? t("exceededTime") : t("exceeded")}
            </p>
            <p className="stats-row__item">
              <span
                className="dot"
                style={{ backgroundColor: StatusesColors.OnHold }}
              ></span>
              {t("onHold")}
            </p>
          </div>
        </>
      )}

      {!isAteCasesStatisticsDataLoaded && (
        <div className="d-flex justify-content-center">
          <ProgressSpinner />
        </div>
      )}
    </Card>
  );
};

export default OpenATECases;
